import { FormControl, FormGroup, FormLabel, TextField, Tooltip } from "@mui/material";
import { RetailerTemplateSettings } from "../../api";

export interface RetailerTemplateSettingsControlProps {
  settings?: RetailerTemplateSettings;
  onChange: (settings: Partial<RetailerTemplateSettings>) => void;
}

export const RetailerTemplateSettingsControl = (props: RetailerTemplateSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Template settings</FormLabel>
      <FormGroup>
        <Tooltip title="Required for XLSX: sheet name where to export data">
          <TextField label="Sheet" required variant="standard" value={settings?.sheet ?? ""} onChange={(e) => onChange({ sheet: e.target.value })} />
        </Tooltip>
        <Tooltip title={<div style={{ whiteSpace: "pre-line" }}>{"Required for XLSX: row that contains template row with tokens to replace\nOptional for CSV: header row, default 1"}</div>}>
          <TextField label="Row" variant="standard" type="number" value={settings?.row ?? ""} onChange={(e) => onChange({ row: parseInt(e.target.value) })} />
        </Tooltip>
      </FormGroup>
    </FormControl>
  );
};
